module.exports = __webpack_public_path__ + "static/media/cert-star.0b8616cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Certificate/cert-star.svg
// module id = 130
// module chunks = 0